import Cookies from "js-cookie";

const AUTH_COOKIE_NAME = "CatermatAuthToken";

/**
 * Retrieves the authentication token from cookies.
 * @throws Will throw an error if no authentication token is found.
 * @returns The authentication token string.
 */
export function getAuthToken(): string {
    const token = Cookies.get(AUTH_COOKIE_NAME);
    if (!token) {
        throw new Error("No authentication token found. Please log in.");
    }
    return token;
}

/**
 * Retrieves the authentication token from cookies, or returns null if not found.
 * @returns The authentication token string or null.
 */
export function getAuthTokenOptional(): string | null {
    return Cookies.get(AUTH_COOKIE_NAME) ?? null;
}

/**
 * Creates an authorization header object with the Bearer token.
 * @param token - The authentication token.
 * @returns Headers object with Authorization and Accept fields.
 */
export function getAuthHeader(token: string) {
    return {
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
    };
}

/**
 * Creates headers for public (unauthenticated) requests.
 * @returns Headers object with just Accept field.
 */
export function getPublicHeader() {
    return {
        Accept: "*/*",
    };
}
